import { BaseEntity, Entity as DecribeEntity, RelationList } from '@lib/entity';

import { UserGrantsTableItemEntityList } from './user-grants-table-item.entity-list';

import type { UserGrantsTableRow } from '@modules/types/graphql';
import type { UserGrantsTableItemEntity } from './user-grants-table-item.entity';

export type Entity = UserGrantsTableRow | null;

@DecribeEntity('UserGrantsTableRowEntity')
class UserGrantsTableRowEntity extends BaseEntity {
    #index: string;

    key: string;
    name: string;
    isCategory: boolean;
    isAction: boolean;
    categoryId: string;
    parentCategoryId: string;

    @RelationList(() => UserGrantsTableItemEntityList)
    grants: UserGrantsTableItemEntity[];

    constructor(entity: Entity) {
        super(entity);

        this.#index = '0';

        this.key = entity?.key ?? '';
        this.name = entity?.name ?? '';
        this.isCategory = entity?.isCategory ?? false;
        this.isAction = entity?.isAction ?? false;
        this.categoryId = entity?.categoryId ?? '';
        this.parentCategoryId = entity?.parentCategoryId ?? '';
    }

    set index(index: string) {
        this.#index = index;
    }

    get index() {
        return this.#index;
    }
}

export { UserGrantsTableRowEntity };
